import {
  IGenerateStrategyProps,
  IStrategy,
  IStrikeData,
  Leg,
} from "../../../types";

export const generateLowPremiumCalls = (
  params: IGenerateStrategyProps,
  data: IStrikeData[],
  strategies: IStrategy[],
  expiryDuration: number
): IStrategy[] => {
  for (let i = 0; i < data.length; i++) {
    const leg = {
      strikePrice: data[i].strikePrice,
      call: true,
      buy: true,
      quantity: params.lotSize,
      price: data[i].CE?.lastPrice || 0,
    };
    const legs: Leg[] = [leg];
    const { strikePrice, price, quantity } = leg;
    const underlyingValue = params.data.underlyingValue;
    const approxMargin = price * quantity;

    const maxLossROI = 100;
    const breakEven = strikePrice + price - underlyingValue;
    const strategy: IStrategy = {
      title: "Low Premium Call - " + strikePrice,
      legs: legs,
      callBreakEven: breakEven,
      callBreakEvenPercentage: (breakEven / params.data.underlyingValue) * 100,
      maxLoss: leg.price * leg.quantity,
      maxProfit: Infinity,
      riskRewardRatio: Infinity,
      maxLossROI,
      maxProfitROI: Infinity,
      approxMargin: approxMargin,
      expiryDuration: expiryDuration,
      lotSize: params.lotSize,
      alert:
        "Entire capital is under risk. Please consider a risk management mechanism to avoid capital wipeout",
    };
    if (breakEven / underlyingValue < 0.1) strategies.push(strategy);
  }
  return strategies;
};
